import Repository from "./Repository";
import store from "@/store";

const resource = "/Subcategory";

export default {
  getCategoriesForSelect() {
    return Repository.get(`${resource}/for-select`)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        console.log(error);
      });
  },
  getCategoriesByCategoryForSelect(categoryId) {
    return Repository.get(`${resource}/${categoryId}/for-select`)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        console.log(error);
      });
  },
  getSubcategoryFilter(categoryId) {
    return Repository.get(
      `${resource}/properties-for-filter?subcatId=${categoryId}`
    )
      .then((response) => {
        return response;
      })
      .catch((error) => {
        console.log(error);
      });
  },
  list(categoryId = null, withDeleted = false) {
    const paramCat = categoryId ? `categoryId=${categoryId}&withDeleted=${withDeleted}` : `?withDeleted=${withDeleted}`;
    return Repository.get(`${resource}?${paramCat}`)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        console.log(error);
      });
  },
  get(id) {
    return Repository.get(`${resource}/${id}`)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        console.log(error);
      });
  },
  create(item) {
    return Repository.post(`${resource}`, item)
        .then((response) => {
          store.commit("setSnack", {
            message: "Изменения сохранены",
            color: "success",
          });
          return response;
        })
        .catch((error) => {
          console.log(error);
        });
  },
  update(item) {
    let url = item.id > 0 ? `${resource}/${item.id}` : `${resource}`;

    return Repository.patch(url, item)
        .then((response) => {
          store.commit("setSnack", {
            message: "Изменения сохранены",
            color: "success",
          });
          return response;
        })
        .catch((error) => {
          console.log(error);
        });
  },
};
